import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.sendTableLoadEvent()
  }

  sendTableLoadEvent() {
    const event = new CustomEvent('ad-table-load')
    window.dispatchEvent(event)
  }
}
